import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { Button } from 'components/form/Button/index';
import RadioAutoLoanList from './RadioAutoLoanList';

const AutoLoanAccountsView = props => {
  return (
    <SectionContainer className={props.className || ''}>
      <FlexContainer className="flex-column">
        <Row className="m-margB0">
          <FlexContainer className="flex-column">
            <Label typeHeader={'h4'} className="H4 margB8 m-text-20">
              {props.title}
            </Label>
            <Label className="Body1 margB24 m-text-14 m-margB20">
              {props.subTitle}
            </Label>
            <RadioAutoLoanList {...props} />
          </FlexContainer>
        </Row>

        <Row>
          <FlexContainer>
            <Button
              id="submitButton"
              onClick={props.onSeeAutoRefinanceOffers}
              mrphType="primary"
              className="loginSecuritySaveButton"
            >
              <Label className="bold">{props.ctaCopy}</Label>
            </Button>
          </FlexContainer>
        </Row>
      </FlexContainer>
    </SectionContainer>
  );
};

AutoLoanAccountsView.defaultProps = {
  title: 'Which auto loan do you want to refinance?',
  subTitle: 'We found these auto loans on your credit report.',
  ctaCopy: 'See Auto Loans',
};

export default AutoLoanAccountsView;
